import { fetchAuthenticated } from '@/lib/utilities/api';
import { createFilterParams } from '@/lib/utilities/api';
import { WatercoachDeelnemerOverview, WatercoachRegistratieInput, WatercoachRegistratieOverview } from '@/lib/types/watercoach';
import { PagedResponse, PaginationQueryParameters } from '@/shared/types/general';
import { useMutation, useQuery, useQueryClient, UseQueryResult } from '@tanstack/react-query';

const QUERY_KEY = ['watercoach'];
const BASE_URL = `${import.meta.env.VITE_CONFIG_API_URL}/watercoach`;

export const useGetWatercoachRegistraties = (
  params?: PaginationQueryParameters<WatercoachDeelnemerOverview>
): UseQueryResult<PagedResponse<WatercoachDeelnemerOverview>, Error> => {
  return useQuery({
    queryKey: [...QUERY_KEY, 'overview', params],
    queryFn: () => fetchAuthenticated<PagedResponse<WatercoachDeelnemerOverview>>(`${BASE_URL}?${createFilterParams(params ?? {})}`),
  });
};

export const useGetWatercoachRegistratie = (deelnemerId?: number): UseQueryResult<WatercoachRegistratieOverview, Error> => {
  return useQuery({
    queryKey: [...QUERY_KEY, deelnemerId],
    queryFn: () => fetchAuthenticated<WatercoachRegistratieOverview>(`${BASE_URL}/${deelnemerId}`),
    enabled: !!deelnemerId,
  });
};

export const useUpsertWatercoachRegistratie = () => {
  const queryClient = useQueryClient();

  return useMutation<WatercoachRegistratieOverview, Error, WatercoachRegistratieInput>({
    mutationFn: (registratie: WatercoachRegistratieInput) =>
      fetchAuthenticated<WatercoachRegistratieOverview>(BASE_URL, {
        json: registratie,
        method: 'POST',
      }),
    mutationKey: [...QUERY_KEY],
    onSuccess: result => {
      queryClient.invalidateQueries({ queryKey: [...QUERY_KEY, result.deelnemerId] });
      queryClient.invalidateQueries({ queryKey: [...QUERY_KEY, 'overview'] });
    },
  });
};
